import type { Recital } from "@recital-master/shared";

export function recitalPathSlug(recital: Recital): string {
  return recital.slug || recital.recitalId;
}

export function recitalPath(recital: Recital): string {
  return `/${recital.studioSlug}/${recitalPathSlug(recital)}`;
}

export function performancePath(recital: Recital, performanceId: string): string {
  return `/${recital.studioSlug}/${recitalPathSlug(recital)}/${performanceId}`;
}

export function dancersPath(recital: Recital): string {
  return `/${recital.studioSlug}/${recitalPathSlug(recital)}/dancers`;
}
